/* global globalThis */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import useAuthorization from "../../hooks/useAuthorization";

export const PublicRoute = ({ component: Component, title, ...rest }) => {
  const { validateToken } = useAuthorization();
  const token = localStorage.getItem("token");
  const isValid = validateToken(token);
  const pathname = globalThis.location.pathname;
  const isPasswordRoute =
    pathname === "/login" ||
    pathname === "/change-password" ||
    pathname === "/forgot-password";
  const routeClassName = `main-div ${isPasswordRoute ? "mobile-view-password-spacing" : ""}`;

  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);
  
  return (
    <Route
      {...rest}
      render={(props) =>
        isValid ? <Redirect to="/dashboard" /> : 
        <div className={routeClassName}>
          <Component {...props} />
        </div>
      }
    />
  );
};

PublicRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  title: PropTypes.string,
};
